import { AppPageShell, GlobalNotAuthorized } from "@/components/ui";
import LawWorksLoader from "@/components/ui/LawWorksLoader/LawWorksLoader";
import { useUser } from "@/components/UserProvider";
import { canAccessReportsArea } from "@/lib/utils/reports/report-navigation";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { Suspense } from "react";

export const Route = createFileRoute("/_auth/reports")({
  component: RouteComponent,
});

function RouteComponent() {
  const { hasPagePermission } = useUser();

  if (!canAccessReportsArea(hasPagePermission)) {
    return <GlobalNotAuthorized />;
  }

  return (
    <Suspense fallback={<LawWorksLoader className="w-full" />}>
      <AppPageShell>
        <Outlet />
      </AppPageShell>
    </Suspense>
  );
}
